module.exports = __webpack_public_path__ + "01_long_yellow.32bff096.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_long_yellow.png
// module id = IiB/
// module chunks = 0